import { StateCreator } from "zustand";
import { DBTCommitModelsData } from "../../../BrightBot/types";
import { ConfigInput, updateConfigValues } from "./dbtSliceUtils";

export interface DBTCommitModelsState {
  commit_models_config: DBTCommitModelsData | null;
}

export interface DBTCommitModelsActions {
  setDBTCommitModelsConfig: (config: DBTCommitModelsData) => void;
  setDBTCommitModelsConfigValues: (
    config: ConfigInput<DBTCommitModelsData>
  ) => void;
  clearDBTCommitModelsConfig: () => void;
  hasCommitModelsConfig: () => boolean;
}

export interface DBTCommitModelsSlice extends DBTCommitModelsState {
  commitModelsActions: DBTCommitModelsActions;
}

const initialState: DBTCommitModelsState = {
  commit_models_config: null,
};

export const createDBTCommitModelsSlice: StateCreator<
  DBTCommitModelsSlice,
  [],
  [],
  DBTCommitModelsSlice
> = (set, get) => ({
  ...initialState,
  commitModelsActions: {
    setDBTCommitModelsConfig: (config: DBTCommitModelsData) => {
      set((state) => ({
        commit_models_config: { ...state.commit_models_config, ...config },
      }));
    },
    setDBTCommitModelsConfigValues: (
      config: ConfigInput<DBTCommitModelsData>
    ) =>
      set((state) => ({
        commit_models_config: updateConfigValues(
          state.commit_models_config,
          config
        ),
      })),
    clearDBTCommitModelsConfig: () =>
      set(() => ({
        commit_models_config: null,
      })),
    hasCommitModelsConfig: () => Boolean(get().commit_models_config),
  },
});
